import { camundaApi } from "@/core/api/camundaApi";
import useSWR from "swr";
import { useRef } from "react";

interface GetPreviousAnswersConfig {
  enableCaching?: boolean;
  dataIsRequired?: boolean;
}

const DEFAULT_CONFIG: GetPreviousAnswersConfig = {
  enableCaching: true,
  dataIsRequired: true,
};

const useGetPreviousAnswers = (
  variableNames?: string | null,
  config?: GetPreviousAnswersConfig
) => {
  const { enableCaching, dataIsRequired } = { ...DEFAULT_CONFIG, ...config };

  const variables = variableNames ? variableNames.split(",") : [];
  const variablesKey =
    !variableNames || variableNames.length === 0 ? null : variables;
  const uniqueSwrKey = useRef(Date.now());
  const swrKey = enableCaching ? variablesKey : [variablesKey, uniqueSwrKey];

  let {
    data: result,
    error,
    isLoading: loading,
  } = useSWR(swrKey, camundaApi.getVariablesForProcess);

  if (result) {
    result = result.data;

    if (dataIsRequired) {
      for (const requiredVariable of variables) {
        if (!Object.keys(result).includes(requiredVariable)) {
          // TODO: handle missing variable in the backend
          console.warn(`Variable ${requiredVariable} missing!`);
        }
      }
    }
  } else {
    return {
      result: {},
      error,
      loading,
    };
  }

  return { result, error, loading };
};

export { useGetPreviousAnswers };
